/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_YouInputs */

const en_of_you = /** @type {(inputs: Of_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const id_of_you = /** @type {(inputs: Of_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Of_YouInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_you = /** @type {((inputs?: Of_YouInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_YouInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_you(inputs)
	return en_of_you(inputs)
});